import { useInitializeUser } from "@/stores/user";
import { useEffect } from "react";

export function UserInitializer() {
  const { error } = useInitializeUser();

  useEffect(() => {
    if (error) {
      console.error("Failed to initialize user:", error);
    }
  }, [error]);

  return null;
}

export default UserInitializer;
